module.exports = __webpack_public_path__ + "static/img/hddy.7d28aa6c.png";